import { ButtonHTMLAttributes, forwardRef } from 'react';
import { useMagnetic } from '../../hooks/useMagnetic';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { strength?: number };

export const MagneticButton = forwardRef<HTMLButtonElement, Props>(({ strength = 0.25, className, children, ...rest }, _ref) => {
  const ref = useMagnetic<HTMLButtonElement>(strength);
  return (
    <button ref={ref} className={className} style={{ transition: 'transform 250ms cubic-bezier(0.16,1,0.3,1)' }} {...rest}>
      {children}
    </button>
  );
});
MagneticButton.displayName = 'MagneticButton';
